import { useMutation, useQueryClient } from "react-query";
import { Post } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";
import { Invite } from "../../types/api/Invite";

export interface PostInviteBuyer {
  to_organization_id: string;
  to_emails: string[];
}
export default () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  return useMutation<Invite, null, PostInviteBuyer>(
    async (body: PostInviteBuyer) =>
      Post(`/api/invite/purchaser`, await getAccessTokenSilently(), body),
    {
      onSuccess: (response, body) => {
        queryClient.invalidateQueries([`invites_${body.to_organization_id}`]);
      },
    }
  );
};
